import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-012ea39a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "服务优势", -1));
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "card-box"
};
const _hoisted_4 = {
  class: "left-img",
  alt: "丰富的行业实战经验"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("h3", null, "丰富的行业实战经验"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 咨询团队由业内顶尖专家组成，拥有丰富的一线实战经验与深层次的研发安全体系理解，曾参与多部开发安全相关标准的编写。 ")], -1));
const _hoisted_6 = {
  class: "card-box"
};
const _hoisted_7 = {
  class: "left-img",
  alt: "丰富的行业实战经验"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("h3", null, "全面系统的安全培训"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 由顶尖安全专家培训辅导，持续赋能企业团队，帮助企业相关人员快速提升安全设计能力、安全开发意识及整体的安全能力。 ")], -1));
const _hoisted_9 = {
  class: "card-box"
};
const _hoisted_10 = {
  class: "left-img",
  alt: "丰富的行业实战经验"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("h3", null, "量体裁衣定制最佳方案"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 依据合规要求，从企业研发架构、业务发展、安全需求等实际情况出发，与现有的开发流程、制度和工具软件融合，完善开发安全体系。 ")], -1));
const _hoisted_12 = {
  class: "card-box"
};
const _hoisted_13 = {
  class: "left-img",
  alt: "丰富的行业实战经验"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("h3", null, "源头规避安全风险"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 覆盖需求、设计、开发、测试、上线运营等各阶段全流程的安全管控，结合风险闭环管理实现从源头上规避安全风险。 ")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'advantage-com active' : 'advantage-com')
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/advantageCom1.png')]]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/advantageCom2.png')]]), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/advantageCom3.png')]]), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [[_directive_lazy, require('@/assets/img/consultingService/advantageCom4.png')]]), _hoisted_14])])], 2);
}